import { useEffect, useState } from 'react';
import { DeliveredLooseOrderView, FullLooseOrder, OrderType, TaskType } from 'types';
import API from '../../API';
import { message } from 'antd';
import moment from 'moment';

export const useDeliveredLooseOrders = () => {
	const [orders, setOrders] = useState<DeliveredLooseOrderView[]>();

	useEffect(() => {
		refetch();
	}, []);

	const refetch = async () => {
		try {
			const fetchedOrders = await API.looseOrders.getDelivered();
			setOrders(fetchedOrders);
		} catch (e) {
			console.trace(e);
			message.error(`Nie udało się pobrać danych ${e}`);
		}
	};

	const fetchFullOrder = async (id: number): Promise<FullLooseOrder | undefined> => {
		try {
			return await API.looseOrder(id).get();
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać zamówienia (${e})`);
			return undefined;
		}
	};

	const createClaimingTask = async (
		orderId: number,
		data: { date: moment.Moment; itemsToClaim: number; price: number }
	): Promise<boolean> => {
		try {
			await API.tasks.put({
				orderId,
				orderType: OrderType.loose,
				type: TaskType.claiming,
				date: data.date,
				itemsToClaim: data.itemsToClaim,
				newPrice: data.price,
			});
			await refetch();
			message.success('Zadanie odbioru zostało utworzone');
			return true;
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się utworzyć zadania (${e})`);
			return false;
		}
	};

	return { orders, refetch, fetchFullOrder, createClaimingTask };
};
